import { useQuery } from '@tanstack/react-query';
import { AffiliateProgramService } from '@/services/affiliate-program.service';
import { AffiliateListResponse } from '@/@types/Affiliates';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDebounce } from 'use-debounce';

export const useFetchAffiliates = (productId: string) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [query, setQuery] = useState("")
  const [debouncedSearchQuery] = useDebounce(query, 300);

  const [status, setStatus] = useState("all")

  const {
    data: affiliatesData,
    isPending: isLoading,
    refetch,
    isRefetching,
    error,
  } = useQuery<AffiliateListResponse>({
    queryKey: ['affiliates', productId, currentPage, status, debouncedSearchQuery],
    queryFn: async () => await AffiliateProgramService.getAffiliatesById(productId, debouncedSearchQuery, status, currentPage),
  });

  const { t } = useTranslation('affiliates')

  return {
    affiliatesData,
    pagination: {
      currentPage,
      lastPage: affiliatesData?.meta.last_page || 1,
      total: affiliatesData?.meta.total || 0,
    },
    setCurrentPage,
    query,
    setQuery,
    status,
    setStatus,
    isLoading,
    refetch,
    isRefetching,
    error: error
      ? (error as Error).message || t('fetch_affiliate_list_error')
      : null,
  };
};